import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {ClientAccountService} from '../../shared/services/client-account.service';
import {UsersService} from "../../shared/services/users.service";

@Injectable()
export class ClientGuardService implements CanActivate {
  constructor(private clientAccountService: ClientAccountService, private router: Router, private userService:UsersService) {
  }

  canActivate(): boolean {
    if (this.clientAccountService.getClient() || this.userService.isCallCenterUser()) {
      return true;
    }
    this.router.navigate(['client-account-choice']);
    return false;
  }
}
